import { configureStore } from '@reduxjs/toolkit'
import { persistReducer, persistStore } from "redux-persist"
import storage from 'localforage'
import systemConfigSlice from './systemConfigSlice';
import { organizationusersList } from '../slices/apiSlice';
import usersSlice from '../pages/ManageOrganizationUsers/userSlice';
import MultiselectRows from "./MultiselectRows"
import MultiselectRowsConditionally from "./MultiselectRowsConditionally"
import commonSlice from "./commonSlice"
import authSlice from '../pages/auth/authSlice';
import monitorsSlice from "../pages/ManagePatient/AddPatient/Components/monitorsSlice"
import subdivisionSlice from "../pages/ManagePatient/AddPatient/Components/subdivisionSlice"
import orgUserSearchSlice from './orgUserSearchSlice'
import patientSearchSlice from './ManagePatientSearchSlice'

const persistConfig = {
    key: 'root', // key for the storage
    storage, // storage engine to use
};
const orgUserSearchPersistConfig = {
    key: 'orgUserSearchData',
    storage,
};
const patientSearchPersistConfig = {
    key: 'patientSearchData',
    storage,
};

const persistedReducer = persistReducer(persistConfig, systemConfigSlice);
const persistedOrgUserSearchReducer = persistReducer(orgUserSearchPersistConfig, orgUserSearchSlice);
const persistedPatientSearchReducer = persistReducer(patientSearchPersistConfig, patientSearchSlice);


export const store = configureStore({
    reducer: {
        [organizationusersList.reducerPath]: organizationusersList.reducer,
        auth: authSlice,
        systemConfigData: persistedReducer,
        commonData: commonSlice,
        userSelect: usersSlice,
        MultiSelectSlice: MultiselectRows,
        monitorsSelect: monitorsSlice,
        subdivSelect: subdivisionSlice,
        MultiSelectSliceConditionally: MultiselectRowsConditionally,
        orgUserSearchData:persistedOrgUserSearchReducer,
        patientSearchData: persistedPatientSearchReducer,


    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(organizationusersList.middleware),
})

export const persistor = persistStore(store);